import type { SelectedDriver } from '@/app/types/creator'

/**
 * Stan kreatora przy powrocie z edycji delegacji (krok + kierowcy z kroków 1–2).
 */
export type CreatorWizardResumePayload = {
  step: number
  subStep: number
  selectedDrivers?: SelectedDriver[]
}

const storageKey = (creatorPathnameAndSearch: string) =>
  `et:creator-wizard-resume:${creatorPathnameAndSearch}`

export function stashCreatorWizardResume(
  creatorPathnameAndSearch: string,
  wizard: CreatorWizardResumePayload,
) {
  if (typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(
      storageKey(creatorPathnameAndSearch),
      JSON.stringify(wizard),
    )
  } catch {
    /* quota / private mode */
  }
}

/** Odczyt bez usuwania — usuń dopiero po zastosowaniu (np. queueMicrotask), żeby Strict Mode nie gubił stanu. */
export function peekCreatorWizardResume(
  creatorPathnameAndSearch: string,
): CreatorWizardResumePayload | null {
  if (typeof sessionStorage === 'undefined') return null
  try {
    const raw = sessionStorage.getItem(storageKey(creatorPathnameAndSearch))
    if (!raw) return null
    const w = JSON.parse(raw) as CreatorWizardResumePayload & {
      step?: number
      subStep?: number
    }
    if (typeof w.step !== 'number') return null
    return {
      step: w.step,
      subStep: w.subStep ?? 0,
      selectedDrivers: Array.isArray(w.selectedDrivers) ? w.selectedDrivers : undefined,
    }
  } catch {
    return null
  }
}

export function clearCreatorWizardResume(creatorPathnameAndSearch: string) {
  if (typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.removeItem(storageKey(creatorPathnameAndSearch))
  } catch {
    /* ignore */
  }
}
